import { motion } from "framer-motion";
import { Check, Phone, Globe, Mail, MapPin, Images, ArrowRight } from "lucide-react";
import { REASONS, REF_THUMBS, PHONE, PHONE_TEL, EMAIL, WEBSITE, LOCATION } from "../lib/data";

const CONTACT = [
  { icon: Phone, value: PHONE, href: `tel:${PHONE_TEL}` },
  { icon: Globe, value: WEBSITE, href: "#home", scroll: "#home" },
  { icon: Mail, value: EMAIL, href: `mailto:${EMAIL}` },
  { icon: MapPin, value: `${LOCATION}, Deutschland`, href: "#kontakt", scroll: "#kontakt" },
];

export default function WhyVoltCore() {
  return (
    <section id="ueber-uns" className="relative py-20 md:py-28 bg-ink-surface" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="font-heading font-black uppercase tracking-tighter text-3xl md:text-5xl text-white mb-12">
          Über <span className="text-volt">VoltCore</span>
        </motion.h2>

        <div className="grid lg:grid-cols-3 gap-12 lg:gap-16">
          <div className="lg:col-span-2">
            <div className="grid sm:grid-cols-2 gap-x-8 gap-y-7">
              {REASONS.map((r, i) => (
                <motion.div key={r.title} data-testid={`reason-${r.title}`}
                  initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
                  className="flex items-start gap-4">
                  <span className="grid place-items-center h-8 w-8 rounded-full border border-volt/50 text-volt shrink-0 mt-0.5">
                    <Check className="h-4 w-4" strokeWidth={3} />
                  </span>
                  <div>
                    <div className="font-bold text-white leading-tight">{r.title}</div>
                    <div className="text-white/50 text-sm mt-0.5">{r.sub}</div>
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="mt-12 grid grid-cols-3 gap-4">
              {REF_THUMBS.map((src, i) => (
                <a key={i} href="#referenzen" data-scroll="#referenzen" data-testid={`why-thumb-${i}`}
                  className="group relative aspect-[4/3] overflow-hidden rounded-xl border border-white/[0.08]">
                  <img src={src} alt="VoltCore Referenz – Elektrovorbereitung & Kernbohrungen" loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/0 transition-colors" />
                </a>
              ))}
            </div>
            <a href="#referenzen" data-scroll="#referenzen" data-testid="mehr-referenzen-btn"
              className="group mt-4 flex items-center justify-between rounded-full border border-white/15 px-6 py-3.5 hover:border-volt transition-colors duration-300">
              <span className="flex items-center gap-3 font-bold text-sm text-white uppercase tracking-wide">
                <Images className="h-4 w-4 text-volt" /> Mehr Referenzen ansehen
              </span>
              <ArrowRight className="h-4 w-4 text-volt group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          <div className="flex flex-col justify-center gap-6 lg:pl-10 lg:border-l lg:border-white/[0.08]">
            {CONTACT.map((c) => (
              <a key={c.value} href={c.href} data-scroll={c.scroll} data-testid={`why-contact-${c.value}`}
                className="group flex items-center gap-4">
                <span className="grid place-items-center h-11 w-11 rounded-full bg-volt/10 text-volt group-hover:bg-volt group-hover:text-black transition-all duration-300 shrink-0">
                  <c.icon className="h-5 w-5" strokeWidth={2} />
                </span>
                <span className="text-white/85 font-semibold group-hover:text-volt transition-colors">{c.value}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
